<template>
  <div>
    <vs-navbar square center-collapsed shadow>
      <vs-navbar-item class="solid">
        <img
          src="https://www.kuntokruunu.fi/wp-content/uploads/2020/07/LOGO.png"
          alt="logo"
        />
      </vs-navbar-item>
    </vs-navbar>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data: () => ({
    darkMode: ""
  }),
  methods: {
    setTheme() {
      if (this.darkMode)
        document
          .getElementsByTagName("BODY")[0]
          .setAttribute("vs-theme", "dark");
      if (!this.darkMode)
        document.getElementsByTagName("BODY")[0].setAttribute("vs-theme", "");
    }
  },
  created() {
    const userPrefersDark =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;

    if (userPrefersDark) this.darkMode = true;
    else this.darkMode = false;
    this.setTheme();
  }
};
</script>

<style scoped>
img {
  max-height: 70px;
}
.solid {
  opacity: 1;
}
</style>
